module.exports = __webpack_public_path__ + "static/media/error.3c385421.png";